/**
 * @generated SignedSource<<053a9497d24a65be83d69874e7f424ab>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSharedSellerChatLoader_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"BuyerChatRespLazy_viewer">;
  readonly " $fragmentType": "PdpRespSharedSellerChatLoader_viewer";
};
export type PdpRespSharedSellerChatLoader_viewer$key = {
  readonly " $data"?: PdpRespSharedSellerChatLoader_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSharedSellerChatLoader_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSharedSellerChatLoader_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BuyerChatRespLazy_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "c724b9ff77f14323bf2e5744e30e47f4";

export default node;
